import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const deleteTieZi = (id) => {
  return api.post(`${ApiEndpointConstants.DELETE_TIEZI}`, { id });
};
